import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VLayout,{attrs:{"align-center":"","justify-center":"","column":"","fill-height":""}},[_c(VProgressCircular,{attrs:{"size":150,"color":"light-green","indeterminate":""}}),_c('div',{staticClass:"headline mt-5"},[_vm._v("\n    Loading...\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }